// @ts-check
import React from 'react';
import ModalWindow from '../../../../../modal/Window';
import { Box, Typography } from '@material-ui/core';

var ErrorDialog = function ErrorDialog(_ref) {
  var header = _ref.header,
      message = _ref.message,
      onClose = _ref.onClose;
  return React.createElement(ModalWindow, {
    onClose: onClose,
    overlay: true,
    renderContent: function renderContent() {
      return React.createElement(Box, {
        m: 2
      }, React.createElement(Typography, null, message));
    },
    footerButtons: {
      submit: {
        children: 'OK',
        onClick: onClose
      }
    },
    header: header,
    style: {
      width: 500
    }
  });
};

export default ErrorDialog;